import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "value"]

  connect() {
    this.updateValue()
  }

  updateValue() {
    if (this.hasValueTarget && this.hasInputTarget) {
      this.valueTarget.textContent = this.inputTarget.value
    }
  }
}
